import { render, staticRenderFns } from "./SettingQnA.vue?vue&type=template&id=b59e6cb2&scoped=true&"
import script from "./SettingQnA.vue?vue&type=script&lang=js&"
export * from "./SettingQnA.vue?vue&type=script&lang=js&"
import style0 from "./SettingQnA.vue?vue&type=style&index=0&id=b59e6cb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59e6cb2",
  null
  
)

export default component.exports